module.exports = __webpack_public_path__ + "mainassets/img/tile-2-3h.ed06dd17.jpg";